export default {"src":"/_next/static/media/OWL.e099a7fa.svg","height":18,"width":18};